export default {
  setBusFeatures(state, payload) {
    state.busFeatures = payload;
  },
};
